import React, { useContext } from "react";
import "./Navbar.css";
import { AuthContext } from "../context/AuthContext";

const Navbar = () => {
  const { user } = useContext(AuthContext);

  return (
    <nav className="navbar">
      {/* Left */}
      <div className="navbar-left">

        {user?.companyLogo && (
          <img
            src={user.companyLogo}
            alt="Company Logo"
            className="company-logo"
          />
        )}

        <div className="company-text">
          <h4 className="company-name">
            {user?.companyName || "Transport Management"}
          </h4>
        </div>
      </div>

      {/* Right */}
      <div className="navbar-right">
        <span className="welcome-text">Welcome,</span>
        <span className="user-name">{user?.name || "Admin"}</span>
      </div>
    </nav>
  );
};

export default Navbar;
